const getPhoneWithoutFormat = (phone: string): string => {
  return phone.replace(/\+1|[-()\s]|^1/g, '')
}

export default getPhoneWithoutFormat
